import React from "react";

import styleClasses from "../../Header/Header.module.scss";
import { quantityCounterOperations as operations } from "../../../models/cart.model";
import { useLocation } from "react-router-dom";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface IQuantityCounter {
  quantity?: number;
  editQuantity?: (operation: operations) => void;
  disabled?: boolean;
  itemDetailCounterStyle?: string;
  itemId?: string | number
}

const QuantityCounter: React.FC<IQuantityCounter> = (props) => {
  const { quantity, editQuantity, disabled = false ,itemDetailCounterStyle, itemId} = props;
  const location = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  const increaseQuantity = () => editQuantity(operations.increase);
  const decreaseQuantity = () => editQuantity(operations.decrease);

  return (
    <div className="text-center me-3">
      <span className={`ls-normal font-Visby-cf ${isDesignV2 ? 'clr-lt-grey f-w5 lh-sm f-s15' : 'f-s14 lh-normal clr-text-grey'}`}>Quantity</span>
      <span
        className={`${styleClasses.card_increments} ${isDesignV2 ? styleClasses.card_increments_mobile_designv2 : ''} d-flex align-items-center ${itemDetailCounterStyle}`}
      >
        <button
          type="button"
          className={`btn btn-custom f-s18 f-w4 ${isDesignV2 ? 'py-0 font-Visby-cf lh-0' : 'py-1 font-rale lh-normal'}`}
          onClick={decreaseQuantity}
          disabled={quantity === 1 || disabled}
          data-testid={`decrease-counter-button-${itemId}`}
        >
          -
        </button>
        <span className="d-inline-block px-4 f-s16" data-testid="quantity-counter">{quantity}</span>
        <button
          type="button"
          className={`btn btn-custom f-s18 f-w4 ${isDesignV2 ? 'py-0 font-Visby-cf lh-0' : 'py-1 font-rale lh-normal'}`}
          data-testid={`increase-counter-button-${itemId}`}
          onClick={increaseQuantity}
          disabled={disabled}
        >
          +
        </button>
      </span>
    </div>
  );
};

export default QuantityCounter;
